import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './w3-ccd.css';
import './app.css';
import App from './App';
import { AuthProvider } from './lib/auth';
import { hataKancalariniKur } from './destek/hataKancasi';
import { pwaBaslat } from './pwa/durum';
import { SorKapisi } from './ui/Sor';

hataKancalariniKur();
// Kurulum istemi uygulama çizilmeden önce gelebilir: dinleyiciler en başta kurulur.
// Servis çalışanı yalnız üretim derlemesinde kaydedilir (geliştirmede bayat kabuk, değişiklikleri gizler).
pwaBaslat(import.meta.env.PROD);

// Tarayıcının varsayılan 8 piksellik gövde boşluğu koyu kabuğun çevresinde beyaz çerçeve bırakıyordu.
// Kütüphane sözleşmesi gereği CSS'te `body` hedeflenmez; boşluk burada sıfırlanır.
document.body.style.margin = '0';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
        <SorKapisi />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

